module.exports = function() {
  return new Worker(__webpack_public_path__ + "64fecb16f0c017e38483.worker.js");
};